import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../../services/axios/axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
// Mui
import { Grid, Typography } from "@mui/material";
import { Card, CardContent } from "@mui/material";
import { CardHeader, Divider } from "@mui/material";
// import { FormControlLabel } from "@mui/material";
// Controls & Components
import ButtonLoading from "../../Controls/Buttons/ButtonLoading";
import TextFieldNormal from "../../Controls/Inputs/TextFieldNormal";

const initialValues = {
  current_password: "",
  new_password: "",
  re_new_password: "",
};

const validationSchema = Yup.object({
  current_password: Yup.string()
    .required(() => i18n.t("yup.password_is_required"))
    .min(8, () => i18n.t("yup.password_is_too_short"))
    .matches(/[^A-Za-z0-9]+/, () =>
      i18n.t("yup.password_can_only_contain_latin_letters_numbers")
    ),
  new_password: Yup.string()
    .required(() => i18n.t("yup.new_password_is_required"))
    .min(8, () => i18n.t("yup.password_is_too_short"))
    .matches(/[^A-Za-z0-9]+/, () =>
      i18n.t("yup.password_can_only_contain_latin_letters_numbers")
    ),
  re_new_password: Yup.string().oneOf([Yup.ref("new_password"), null], () =>
    i18n.t("yup.password_must_match")
  ),
});

export default function ResetUserPass() {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = (e, values, resetForm) => {
    setLoading(true);
    e.preventDefault();
    values = {
      current_password: values.current_password.trim(),
      new_password: values.new_password.trim(),
      re_new_password: values.re_new_password.trim(),
    };
    axiosInstance
      .post("/auth/users/set_password/", {
        current_password: values.current_password,
        new_password: values.new_password,
        re_new_password: values.re_new_password,
      })
      .then((res) => {
        if (res.status === 204) {
          toast.success(() => t("toast.password_successfully_changed"));
          setLoading(false);
          resetForm();
        }
      })
      .catch(() => {
        toast.error(
          () => t("toast.password_not_reset_pls_check_current_password"),
          {
            autoClose: 4000,
          }
        );
        setLoading(false);
      });
  };

  return (
    <>
      <Formik initialValues={initialValues} validationSchema={validationSchema}>
        {({ values, resetForm }) => {
          return (
            <Form>
              <Card sx={{ mt: 3 }}>
                <CardHeader
                  title={
                    <Grid container item>
                      <Grid item xs={12}>
                        <Typography variant='h6'>
                          {t("general.update_password")}
                        </Typography>
                      </Grid>
                    </Grid>
                  }
                  sx={{ backgroundColor: "#f1f1f1" }}
                  // subheader='The information can be edited'
                />
                <Divider />
                <CardContent>
                  <Grid container item spacing={2}>
                    <Grid item xs={12}>
                      <TextFieldNormal
                        variant='outlined'
                        required
                        fullWidth
                        name='current_password'
                        label={t("general.current_password")}
                        type='password'
                        autoComplete='password'
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldNormal
                        variant='outlined'
                        required
                        fullWidth
                        name='new_password'
                        label={t("general.new_password")}
                        type='password'
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextFieldNormal
                        variant='outlined'
                        required
                        fullWidth
                        name='re_new_password'
                        label={t("general.confirm_new_password")}
                        type='password'
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <ButtonLoading
                        type='submit'
                        fullWidth
                        loading={loading}
                        variant='contained'
                        color='primary'
                        onClick={(e) => handleSubmit(e, values, resetForm)}
                        sx={{ mt: 3, mr: 0, mb: 2 }}
                      >
                        {t("button.send_request")}
                      </ButtonLoading>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
